import { HttpHeaders } from '@angular/common/http'
import { environment } from '@env/environment'
import { map } from 'rxjs'
const { msUrl } = environment.api

function mapTree(
  data: any,
  { enabled = false, name = 'status', value = '1' }: any = {
    enabled: false,
    name: 'status',
    value: '1',
  },
) {
  data.forEach((item: any) => {
    const { id, label } = item
    item.title = label
    item.key = id

    if (enabled) {
      item.disabled = !(item[name] == value)
    }

    if (item.children) {
      mapTree(item.children, { enabled, name, value })
    } else {
      item.isLeaf = true
    }
  })

  return data
}

function getDictionaryData(http: any, code: string, prev: string = msUrl.core) {
  return http.get(`${prev}/dictionaries/${code}/list?isRead=true`).pipe(
    map((res: any) => {
      const { data = [] } = res
      data.map((item: any) => ({ label: item.label, value: item.value }))
      return data
    }),
  )
}

function asyncExec(callback: any): void {
  new Promise((resolve) => {
    resolve(1)
  }).then(callback)
}

function buildMenuTree(data: any, arrayService: any): any {
  const tree = [] as any

  arrayService.treeToArr(
    data.filter((item: any) => item.meta.hideMenu != true),
    {
      cb: (item: any) => {
        const { id, parentId: parent_id, label: text, path: link, path, icon, status, meta } = item

        if (!meta.hideMenu) {
          const menuObj: any = {
            id,
            parent_id,
            text,
            path,
            disabled: status != '1',
            icon: !link ? icon : { type: 'icon', value: icon },
          }

          if (link && link.startsWith('/blank/bigscreen')) {
            menuObj.externalLink = `${link}`
            menuObj.target = '_blank'
          } else {
            menuObj.link = link
          }

          tree.push(menuObj)
        }
      },
    },
  )

  return tree
}

function initMenuTrees(
  http: any,
  arrayService: any,
  callback: any = (tree: any) => {},
  url = `${msUrl.auth}/resources/uerRouter?isRead=true`,
): void {
  http.get(url).subscribe((res: any) => {
    const { data } = res as any
    callback(buildMenuTree(data, arrayService))
  })
}

function downLoadFile(data: any, type: string, fileName: string, callback: any = () => {}) {
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.style.display = 'none'
  const blob = new Blob([data], { type: type })
  const url = window.URL.createObjectURL(blob)
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)
  callback()
}

const fileTypeMap = {
  png: 'image/png',
  jpeg: 'image/jpeg',
  jpg: 'image/jpg',
  gif: 'image/gif',
  pdf: 'application/pdf',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  doc: 'application/msword',
  xls: 'application/vnd.ms-excel',
  ppt: 'application/vnd.ms-powerpoint',
} as any

function requestFile(
  http: any,
  fileName: any,
  fileUrl: any,
  callback: any = () => {},
  headers = new HttpHeaders({}),
): void {
  const match = fileName.match(/\.([^.]+)$/)

  if (match) {
    const fileType = match[1]
    http
      .get(fileUrl, undefined, {
        responseType: 'arraybuffer',
        headers,
      })
      .subscribe((res: any) => {
        const type = fileTypeMap[fileType]
        downLoadFile(res, type, fileName, callback)
      })
  }
}

function getSpecifiedAttributeValues(obj: any, propertyNames: any): any {
  return Object.fromEntries(propertyNames.map((prop: any) => [prop, obj[prop]]))
}

function detectClientType() {
  const userAgent = navigator.userAgent.toLowerCase()
  const isIOS = /ipad|iphone|ipod/.test(userAgent) && !(window as any).MSStream
  const isAndroid = userAgent.indexOf('android') > -1

  if (isIOS) {
    return 'iOS'
  } else if (isAndroid) {
    return 'Android'
  } else if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  } else if (/macintosh|mac os x/i.test(userAgent)) {
    return 'Mac OS'
  } else if (/windows/i.test(userAgent)) {
    return 'Windows'
  } else if (/linux/i.test(userAgent)) {
    return 'Linux'
  } else {
    return 'Unknown'
  }
}

function findTopParentNode(data: any, targetId: any, targetPId: any = null) {
  const map: any = {}
  const recurse = (data: any) => {
    for (let item of data) {
      if (item.id !== undefined) {
        map[item.id] = item
      }

      if (item.children && item.children.length > 0) {
        recurse(item.children)
      }
    }
  }

  recurse(data)
  let node = map[targetId]

  while (node && node.parentId !== targetPId && node.parentId !== undefined) {
    node = map[node.parentId]
  }

  return node
}

function numberPipe(value: any, format = '1.0-2') {
  if (isNaN(value)) {
    return ''
  }

  // 解析格式
  const [minInt, fractionPart] = format.split('.')
  const [minFraction = 0, maxFraction = 2] = fractionPart
    ? fractionPart.split('-').map(Number)
    : [0, 2]

  // 格式化数字
  const options = {
    minimumIntegerDigits: parseInt(minInt, 10),
    minimumFractionDigits: minFraction,
    maximumFractionDigits: maxFraction,
    useGrouping: true, // 使用千位分隔符
  }

  return new Intl.NumberFormat('en-US', options).format(value)
}

function getIntegerPart(value: any) {
  if (isNaN(value)) {
    return ''
  }
  return Math.trunc(value).toString() // 去掉小数部分，返回整数部分
}

function getDecimalPart(value: any) {
  if (isNaN(value)) {
    return ''
  }
  const parts = value.toString().split('.')
  return parts[1] ? `.${parts[1]}` : '' // 返回小数部分，带小数点
}

function parseNumber(input: any) {
  return parseFloat(input.replace(/,/g, '')) // 去掉千位分隔符并转换为数值
}

export {
  mapTree,
  getDictionaryData,
  asyncExec,
  initMenuTrees,
  buildMenuTree,
  downLoadFile,
  fileTypeMap,
  requestFile,
  getSpecifiedAttributeValues,
  detectClientType,
  findTopParentNode,
  numberPipe,
  getIntegerPart,
  getDecimalPart,
  parseNumber,
}
